export default function prepareInitialState(data, key) {
  switch (key) {
    case "RequestForQuotation":
      return {
        dueDate: null,
        materialRequest: { label: data?.number, value: data?.id },
        item: data?.itemDetail?.map((item) => ({
          ...item,
          item: { ...item.item, value: item.item.id },
        })),
        status: {
          label: "Open",
          value: "Open",
        },
        itemType: {
          label: data?.itemType,
          value: data?.itemType,
        },
      };
    case "Quotation":
      return {
        quotations: data.map((item) => ({
          ...item,
          number: item.number,
          isApproved: false,
        })),
      };
    default:
      return data;
  }
}

export const formatQuotationItems = (items) =>
  items.map((itemData) => ({
    ...itemData,
    itemName: itemData.item.itemName,
    unit: itemData.item?.unitOfMeasure?.label,
    quantity: itemData.quantity,
    price: itemData.amount,
  }));
